export default "__VITE_ASSET__CxwCsYY5__"